import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { CacheStoreKey } from "../../enum/cacheStore.enum";
import { handleNetworkResponse } from "../../util/helper";
import { ConfigProp } from "../../types/ConfigProp";

// Define a service using a base URL and expected endpoints
export const configPropApi = createApi({
  reducerPath: "configPropApi",
  tagTypes: ['configProps'],
  baseQuery: fetchBaseQuery({ baseUrl: "" }),
  endpoints: (build) => ({
    // mutation api
    createConfigProp: build.mutation({
      queryFn: async (configProp: Omit<ConfigProp, 'id'>) => {
        const response = await axios.post(
          `/configProp/create`,
          configProp
        );
        return handleNetworkResponse(response, null);
      },
      invalidatesTags: ['configProps'],
    }),

    updateConfigProp: build.mutation({
      queryFn: async (configProp: ConfigProp) => {
        const response = await axios.post(
          `/configProp/update`,
          configProp
        );
        return handleNetworkResponse(response, null);
      },
      invalidatesTags: ['configProps'],
    }),

    resetConfigProp: build.mutation({
      queryFn: async (args: CacheStoreKey |'all') => {
        const response = await axios.post(`/configProps/reset?type=${args}`);
        return handleNetworkResponse(response, null);
      },
      invalidatesTags: ['configProps'],
    }),

    // read api
    readConfigProps: build.query({
      queryFn: async () => {
        const response = await axios.get<ConfigProp>(`/configProps`);
        return handleNetworkResponse(response, []);
      },
      providesTags: ['configProps'],
    }),
  }),
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateConfigPropMutation,
  useResetConfigPropMutation,
  useUpdateConfigPropMutation,
  useLazyReadConfigPropsQuery,
  useReadConfigPropsQuery
} = configPropApi;

export type ConfigPropsApiType = typeof configPropApi;